import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row text-center mt-0 mb-0" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "d-flex flex-row justify-content-center align-items-center" }
const _hoisted_5 = {
  style: {"width":"350px","margin-bottom":"10px","margin-top":"10px"},
  class: "text-center"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "d-flex flex-column flex-sm-row justify-content-center align-items-center modal-buttons mt-3 pt-3 border-top w-100 gap-2",
  style: {"border-top-color":"#eef1f5 !important"}
}

import {ErrorToast, SuccessToast} from '@/components/VueToast';
import SignaturePad from 'signature_pad';
import {onMounted, ref, toRefs} from 'vue';
import {useI18n} from 'vue-i18n';
import unemployedPrivateCoachingService from "@/api/Unemployed/PrivateCoaching";


export default /*@__PURE__*/_defineComponent({
  __name: 'DigitalSignatureForm',
  props: {
  documentId: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  emits: ['update:modelValue', 'update:missingDigitalSignature', 'update:submitForm'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const {t} = useI18n();
const canvasRef = ref<HTMLCanvasElement | null>(null);
const existingDigitalSignature = ref('');
const isLoaded = ref(false);
let signaturePad: any = null;

const props = __props;

const documentId = toRefs(props)['documentId'];

const formData = ref<any>({
  digitalSignature: '',
  documentId: documentId.value,
});

async function saveSignature() {
  if (signaturePad && !signaturePad.isEmpty()) {
    formData.value.digitalSignature = signaturePad.toDataURL('image/png');
  } else {
    formData.value.digitalSignature = ''; // Clear if empty
  }

  // // 👇 OVDJE LOG
  // console.log('Base64 length:', formData.value.digitalSignature.length);
  //
  // const sizeMB = (formData.value.digitalSignature.length * 3) / 4 / 1024 / 1024;
  // console.log('Signature size MB:', sizeMB.toFixed(2));


  try {
   await unemployedPrivateCoachingService.saveDigitalSignature(
       documentId.value,
       formData.value
   );

    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

const clearSignature = () => {
  if (signaturePad) {
    signaturePad.clear();
    formData.value.digitalSignature = '';
  }
};

async function getDocumentData() {
  const {data} = await unemployedPrivateCoachingService.getDigitalSignature(
      documentId.value,
  );

  existingDigitalSignature.value = data.data.digitalSignatureBase64
}

onMounted(async () => {
  await getDocumentData();

  if (canvasRef.value) {
    signaturePad = new SignaturePad(canvasRef.value, {
      backgroundColor: '#fff',
      penColor: 'rgb(0, 0, 0)',
    });
  }

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("small", {
          class: "text-muted d-block text-uppercase font-weight-bold mb-2",
          style: {"font-size":"11px","letter-spacing":"0.8px"}
        }, [
          _createElementVNode("i", { class: "fa-solid fa-pen-nib mr-1 text-primary" }),
          _createTextVNode(" Neue Signatur zeichnen ")
        ], -1)),
        _createElementVNode("canvas", {
          id: "signature-canvas",
          width: "350",
          height: "200",
          style: {"border":"1px solid rgb(208, 208, 208)"},
          ref_key: "canvasRef",
          ref: canvasRef
        }, null, 512),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.digitalSignature) = $event)),
          type: "hidden"
        }, null, 512), [
          [_vModelText, formData.value.digitalSignature]
        ])
      ])
    ]),
    (existingDigitalSignature.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("small", {
                class: "text-muted d-block text-uppercase font-weight-bold mb-2",
                style: {"font-size":"11px","letter-spacing":"0.8px"}
              }, [
                _createElementVNode("i", { class: "fa-solid fa-signature mr-1 text-success" }),
                _createTextVNode(" Aktuelle Signatur ")
              ], -1)),
              _createElementVNode("img", {
                class: "img-fluid shadow-sm",
                src: existingDigitalSignature.value,
                alt: "Signature",
                style: {"width":"100%","height":"150px","object-fit":"contain","border":"1px solid #dee2e6","background-color":"#f8f9fa","border-radius":"6px","padding":"10px"}
              }, null, 8, _hoisted_6)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "btn btn-soft-red font-weight-bold mr-0 mr-md-3 px-4 w-100 w-sm-auto d-inline-flex align-items-center justify-content-center",
        style: {"min-height":"38px"},
        onClick: clearSignature
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa-solid fa-eraser mr-2" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('general.button.delete')), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary font-weight-bold ml-0 ml-md-3 mt-3 mt-md-0 px-4 w-100 w-sm-auto d-inline-flex align-items-center justify-content-center",
        style: {"min-height":"38px"},
        onClick: saveSignature
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa-solid fa-floppy-disk mr-2" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('general.button.save')), 1)
      ])
    ])
  ], 64))
}
}

})